import React, { useEffect } from "react";
import Chart from "./highcharts/Chart";
import highcharts3d from "highcharts/highcharts-3d";
import Highcharts, { color } from "highcharts";

import { useDispatch } from "react-redux";
// import {
//   forecastAlertSum,
//   forecastTicketCount,
//   forecastFrequentPerdiodics,
//   forecastIdleUser,
//   forecastInactiveAlert,
//   forecastLatencyPacketLoss,
// } from "./data/data";
import {
  forecastAlertSum,
  forecastTicketCount,
  forecastFrequentPerdiodics,
  forecastIdleUser,
  forecastInactiveAlert,
  forecastLatencyPacketLoss,
} from "./data/data_weekly";
import { getDataTicketsAlerts } from "../../../redux/action/action";
import { UseContextData } from "../../../context/dateContext";

highcharts3d(Highcharts);

const parseDate = (dateString) => {
  const [year, month, day] = dateString.split("-").map(Number);
  return Date.UTC(year, month - 1, day); // Month is 0-indexed in JS Date.UTC
};

const SingleAreaChartHC = ({ filter = ["tickets"] }) => {
  const { isDarkTheme } = UseContextData();

  let data = [];

  const dispatch = useDispatch();

  const data_alerts = forecastAlertSum.map(([dateString, value]) => [
    parseDate(dateString),
    Math.round(100 * Number(value)) / 100,
  ]);

  const data_tickets = forecastTicketCount.map(([dateString, value]) => [
    parseDate(dateString),
    Math.round(100 * Number(value)) / 100,
  ]);

  const data_frequent_periodics = forecastFrequentPerdiodics.map(
    ([dateString, value]) => [
      parseDate(dateString),
      Math.round(100 * Number(value)) / 100,
    ]
  );

  const data_idle_users = forecastIdleUser.map(([dateString, value]) => [
    parseDate(dateString),
    Math.round(100 * Number(value)) / 100,
  ]);

  const data_inactive_users = forecastInactiveAlert.map(
    ([dateString, value]) => [
      parseDate(dateString),
      Math.round(100 * Number(value)) / 100,
    ]
  );

  const data_packet_loss = forecastLatencyPacketLoss.map(
    ([dateString, value]) => [
      parseDate(dateString),
      Math.round(100 * Number(value)) / 100,
    ]
  );

  const getData = async () => {
    const requestParams = { filter: filter };
    try {
      const response = await dispatch(getDataTicketsAlerts(requestParams));
      const responseData = response?.payload?.data;

      const {
        data_alerts,
        data_tickets,
        data_frequent_periodics,
        data_idle_users,
        data_inactive_users,
        data_packet_loss,
      } = responseData;
    } catch (error) {
      console.log(error);
    }
  };

  const forecastDate = parseDate("2024-08-31");

  // load the data with filter
  useEffect(() =>
    // fetch data

    {}, [filter]);

  // Función para verificar si la serie debe mostrarse
  const shouldShowSeries = (seriesKey, type) => {
    // console.log("filter", filter);

    if (!filter) {
      return false;
    }

    if (filter.length === 1 && filter.includes("alerts") && type === "alert") {
      return true;
    }

    if (
      filter.length === 2 &&
      filter.includes("alerts") &&
      filter.includes("tickets")
    ) {
      return true;
    }

    if (filter.includes(seriesKey)) return true;
    else return false;
  };

  const chartOptions = {
    chart: {
      height: 500,
      backgroundColor: isDarkTheme ? "#3D3D3D" : "#ffffff",

      type: "area",
      options3d: {
        enabled: true,
        alpha: 15,
        beta: 30,
        depth: 200,
      },
    },
    title: {
      text: null,
      align: "left",
    },
    yAxis: {
      title: {
        text: null,
        x: -40,
      },
      labels: {
        format: "{value:,.0f} ",
        style: {
          // fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
      gridLineDashStyle: "Dash",
    },
    xAxis: {
      type: "datetime",
      labels: {
        format: "{value:%b %Y}", // Formato para mostrar el mes y el año
        rotation: -45,
        style: {
          // fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
      tickInterval: 30 * 24 * 3600 * 1000, // Intervalo de un mes
      plotLines: [
        {
          value: forecastDate, // La fecha que quieres marcar
          color: isDarkTheme ? "#ffffff" : "gray", // Color de la línea
          width: 2, // Grosor de la línea
          dashStyle: "Dash", // Estilo de la línea
          label: {
            text: "Prediction", // Texto que aparecerá junto a la línea
            align: "left", // Alineación del texto
            x: 15,
            style: {
              color: isDarkTheme ? "#ffffff" : "gray", // Color del texto
              fontSize: "18px", // Tamaño de fuente
              fontWeight: "bold", // Negrita
            },
          },
        },
      ],
    },
    plotOptions: {
      area: {
        depth: 40,
        marker: {
          enabled: false,
        },
        states: {
          inactive: {
            enabled: false,
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: true,
      itemStyle: {
        color: isDarkTheme ? "#ffffff" : "#27403F",
      },
    },
    series: [
      shouldShowSeries("tickets", "ticket") && {
        name: "All tickets",
        data: data_tickets,
        color: "#2CAFFE",
      },

      shouldShowSeries("frequent-periodics", "alert") && {
        name: "Frequent Periodics Alerts",
        data: data_frequent_periodics,
        color: "#544fc5",
      },
      shouldShowSeries("idle-user", "alert") && {
        name: "Idle User Alerts",
        data: data_idle_users,
        color: "#ffcc00",
      },
      shouldShowSeries("inactive-alert", "alert") && {
        name: "Inactive Device Alerts",
        data: data_inactive_users,
        color: "#6B8ABC",
      },
      shouldShowSeries("latency-packet-loss", "alert") && {
        name: "Packet Loss Alerts",
        data: data_packet_loss,
        color: "#2EE0CA",
      },
      shouldShowSeries("all-alerts", "alert") && {
        name: "All alerts",
        data: data_alerts,
        color: "#feb56a",
      },
    ].filter(Boolean), // Filtra las series que no son visibles
  };

  return <Chart options={chartOptions} highcharts={Highcharts} />;
};

export default SingleAreaChartHC;
